(() => {
  const bind = (scope = document) => {
    scope.querySelectorAll('[data-pixel-editorial]').forEach((section) => {
      if (section.dataset.pixelEditorialBound) return;
      section.dataset.pixelEditorialBound = 'true';
      const events = new AbortController();
      section.querySelectorAll('[data-pixel-style-question]').forEach(link => {
        link.addEventListener('click', event => {
          const target = document.getElementById(link.getAttribute('href').slice(1));
          const question = target?.querySelector('textarea[name="contact[body]"]');
          if (!question || !section.contains(target)) return;
          event.preventDefault();
          if (!question.value.trim()) {
            const title = section.querySelector('h1')?.textContent.trim() || 'this flower gift';
            question.value = `I’m interested in ${title}. Please confirm the pictured arrangement, included items, dimensions and price before I order. My preferred style from the photos is: `;
            question.dispatchEvent(new Event('input', { bubbles: true }));
          }
          target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          question.focus({ preventScroll: true });
          question.setSelectionRange(question.value.length, question.value.length);
        }, { signal: events.signal });
      });
      const back = section.querySelector('[data-pixel-catalog-return]');
      // Only restore a same-shop collection that actually led to this product.
      try {
        const context = JSON.parse(sessionStorage.getItem('pixel:catalog-return') || 'null');
        if (back && context?.productPath === location.pathname) {
          const source = new URL(context.catalogPath, location.origin);
          const root = new URL(window.Shopify?.routes?.root || '/', location.origin).pathname;
          const collection = ['all-bouquets', 'all', 'pattern'].some(handle => source.pathname === `${root}collections/${handle}`);
          const patternsPage = source.pathname === `${root}pages/about` && source.searchParams.get('view') === 'pixel-patterns';
          if (source.origin === location.origin && (collection || patternsPage)) {
            back.href = source.pathname + source.search + source.hash;
            back.textContent = 'Back to your selection';
          }
        }
      } catch (error) {
        // Storage is optional; a normal bouquet/PDF collection link remains usable.
        console.warn('Pixel selection return context unavailable:', error.message);
      }
      section.querySelector('[data-pixel-buy-jump]')?.addEventListener('click', event => {
        const id = event.currentTarget.getAttribute('href').slice(1);
        const target = document.getElementById(id);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        const control = target.querySelector('select:not([disabled]), input:not([type="hidden"]):not([disabled]), textarea:not([disabled])');
        (control || target).focus({ preventScroll: true });
      }, { signal: events.signal });
      const opener = section.querySelector('[data-pixel-editorial-open]');
      const dialog = section.querySelector('[data-pixel-editorial-dialog]');
      const enlarged = section.querySelector('[data-pixel-editorial-dialog-image]');
      const sticky = section.querySelector('[data-pixel-editorial-sticky]');
      const zoomStatus = section.querySelector('[data-pixel-zoom-status]');
      const loader = section.querySelector('[data-pixel-zoom-loader]');
      let returnFocus = opener;
      let zoomEvents;
      let zoomRequest = 0;
      let previousOverflow = '';
      let scrollLocked = false;
      let frame = 0;
      let disposed = false;
      let observer;
      let detachObserver;
      const restoreScroll = () => {
        if (!scrollLocked) return;
        document.body.style.overflow = previousOverflow;
        scrollLocked = false;
      };
      const cleanup = () => {
        if (disposed) return;
        disposed = true;
        events.abort();
        zoomEvents?.abort();
        zoomRequest++;
        if (frame) window.cancelAnimationFrame(frame);
        frame = 0;
        observer?.disconnect();
        detachObserver?.disconnect();
        if (sticky) sticky.hidden = true;
        const wasOpen = dialog?.open;
        if (wasOpen) dialog.close();
        restoreScroll();
        if (wasOpen && returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
      };
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target === section || event.target.contains(section)) cleanup();
      }, { signal: events.signal });
      detachObserver = new MutationObserver(() => {
        if (!section.isConnected) cleanup();
      });
      detachObserver.observe(document.body, { childList: true, subtree: true });
      if (opener && dialog && enlarged && typeof dialog.showModal === 'function') {
        const stage = dialog.querySelector('[data-pixel-lightbox-stage]');
        const zoomToggle = dialog.querySelector('[data-pixel-zoom-toggle]');
        const thumbnails = [...section.querySelectorAll('[data-pixel-image]')];
        let zoomed = false;
        let fittedWidth = 0;
        let fittedHeight = 0;
        let lightboxIndex = -1;
        const imageKey = value => {
          const url = new URL(value, document.baseURI);
          url.searchParams.delete('width');
          return url.href;
        };
        const fitImage = () => {
          if (!enlarged.naturalWidth || enlarged.hidden) return;
          const scale = Math.min(1, stage.clientWidth / enlarged.naturalWidth, stage.clientHeight / enlarged.naturalHeight);
          fittedWidth = enlarged.naturalWidth * scale;
          fittedHeight = enlarged.naturalHeight * scale;
          zoomed = false;
          dialog.dataset.zoomed = 'false';
          enlarged.style.width = `${fittedWidth}px`;
          enlarged.style.height = `${fittedHeight}px`;
          zoomToggle.hidden = scale >= .98;
          zoomToggle.setAttribute('aria-pressed', 'false');
          zoomToggle.setAttribute('aria-label', 'Zoom in');
          stage.scrollTo(0, 0);
        };
        const toggleZoom = () => {
          if (zoomToggle.hidden || enlarged.hidden) return;
          zoomed = !zoomed;
          const scale = zoomed ? Math.min(2.5, enlarged.naturalWidth / fittedWidth) : 1;
          enlarged.style.width = `${fittedWidth * scale}px`;
          enlarged.style.height = `${fittedHeight * scale}px`;
          dialog.dataset.zoomed = String(zoomed);
          zoomToggle.setAttribute('aria-pressed', String(zoomed));
          zoomToggle.setAttribute('aria-label', zoomed ? 'Zoom out' : 'Zoom in');
          stage.scrollTo((stage.scrollWidth - stage.clientWidth) / 2, (stage.scrollHeight - stage.clientHeight) / 2);
        };
        const showImage = (source, alt) => {
          zoomed = false;
          dialog.dataset.zoomed = 'false';
          stage.scrollTo(0, 0);
          zoomToggle.setAttribute('aria-pressed', 'false');
          zoomToggle.setAttribute('aria-label', 'Zoom in');
          const url = new URL(source, document.baseURI);
          const shopifyImage = url.hostname === location.hostname || url.hostname === 'cdn.shopify.com' || url.hostname.endsWith('.shopifycdn.com') || url.hostname.endsWith('.shopifycdn.net');
          if (shopifyImage && ['https:', 'http:'].includes(url.protocol)) url.searchParams.set('width', '2400');
          lightboxIndex = thumbnails.findIndex(link => imageKey(link.dataset.pixelImage) === imageKey(source));
          dialog.querySelectorAll('[data-pixel-lightbox-direction]').forEach(button => { button.hidden = thumbnails.length < 2; });
          zoomEvents?.abort();
          zoomEvents = new AbortController();
          const request = ++zoomRequest;
          const isCurrent = () => !disposed && request === zoomRequest && dialog.open;
          const showFailure = () => {
            if (!isCurrent()) return;
            enlarged.hidden = true;
            enlarged.setAttribute('aria-busy', 'false');
            loader.hidden = true;
            zoomStatus.classList.remove('pixel-gallery-sr-only');
            zoomStatus.textContent = 'Image unavailable. Try another photo.';
            zoomStatus.hidden = false;
          };
          const showLoaded = async () => {
            if (!isCurrent()) return;
            if (!enlarged.naturalWidth) { showFailure(); return; }
            try {
              await enlarged.decode();
              if (!isCurrent()) return;
              enlarged.hidden = false;
              enlarged.setAttribute('aria-busy', 'false');
              loader.hidden = true;
              zoomStatus.hidden = true;
              zoomStatus.textContent = '';
              fitImage();
            } catch (error) { showFailure(); }
          };
          enlarged.addEventListener('load', showLoaded, { signal: zoomEvents.signal });
          enlarged.addEventListener('error', showFailure, { signal: zoomEvents.signal });
          enlarged.hidden = true;
          enlarged.setAttribute('aria-busy', 'true');
          zoomToggle.hidden = true;
          loader.hidden = false;
          zoomStatus.classList.add('pixel-gallery-sr-only');
          zoomStatus.textContent = 'Loading image';
          zoomStatus.hidden = false;
          enlarged.alt = alt || '';
          enlarged.loading = 'eager';
          const reuseLoadedImage = enlarged.src === url.href && enlarged.complete && enlarged.naturalWidth > 0;
          if (!reuseLoadedImage) {
            if (enlarged.src === url.href && enlarged.complete && !enlarged.naturalWidth) enlarged.removeAttribute('src');
            enlarged.src = url.href;
          }
          if (reuseLoadedImage) void showLoaded();
        };
        const openImage = (trigger, source, alt) => {
          if (disposed || dialog.open) return;
          returnFocus = trigger;
          previousOverflow = document.body.style.overflow;
          dialog.showModal();
          scrollLocked = true;
          document.body.style.overflow = 'hidden';
          showImage(source, alt);
        };
        opener.disabled = false;
        opener.addEventListener('click', () => {
          const image = section.querySelector('.pixel-product-main');
          if (image) openImage(opener, image.src || image.currentSrc, image.alt);
        }, { signal: events.signal });
        section.querySelectorAll('[data-pixel-editorial-reference]').forEach(trigger => {
          trigger.disabled = false;
          trigger.addEventListener('click', () => openImage(trigger, trigger.dataset.pixelEditorialReference, trigger.querySelector('img')?.alt), { signal: events.signal });
        });
        const moveImage = direction => {
          if (thumbnails.length < 2) return;
          const next = (lightboxIndex + direction + thumbnails.length) % thumbnails.length;
          thumbnails[next].click();
          showImage(thumbnails[next].dataset.pixelImage, thumbnails[next].dataset.pixelAlt);
        };
        dialog.querySelectorAll('[data-pixel-lightbox-direction]').forEach(button => {
          button.addEventListener('click', () => moveImage(Number(button.dataset.pixelLightboxDirection)), { signal: events.signal });
        });
        dialog.addEventListener('keydown', event => {
          if (zoomed && ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) {
            event.preventDefault();
            stage.scrollBy({ left: event.key === 'ArrowRight' ? 80 : event.key === 'ArrowLeft' ? -80 : 0, top: event.key === 'ArrowDown' ? 80 : event.key === 'ArrowUp' ? -80 : 0, behavior: 'auto' });
          } else if (['ArrowLeft', 'ArrowRight'].includes(event.key)) {
            event.preventDefault();
            moveImage(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, { signal: events.signal });
        let touchStart;
        stage.addEventListener('touchstart', event => {
          touchStart = !zoomed && event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
        }, { signal: events.signal, passive: true });
        stage.addEventListener('touchend', event => {
          if (!touchStart || zoomed || !event.changedTouches.length) return;
          const dx = event.changedTouches[0].clientX - touchStart.x;
          const dy = event.changedTouches[0].clientY - touchStart.y;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) moveImage(dx < 0 ? 1 : -1);
          touchStart = null;
        }, { signal: events.signal, passive: true });
        stage.addEventListener('touchcancel', () => { touchStart = null; }, { signal: events.signal, passive: true });
        zoomToggle.addEventListener('click', toggleZoom, { signal: events.signal });
        enlarged.addEventListener('click', toggleZoom, { signal: events.signal });
        window.addEventListener('resize', () => { if (dialog.open) fitImage(); }, { signal: events.signal });
        section.querySelector('[data-pixel-editorial-close]').addEventListener('click', () => dialog.close(), { signal: events.signal });
        stage.addEventListener('click', event => { if (event.target === stage || event.target.classList.contains('pixel-lightbox-canvas')) dialog.close(); }, { signal: events.signal });
        dialog.addEventListener('close', () => {
          zoomEvents?.abort();
          zoomRequest++;
          restoreScroll();
          if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
        }, { signal: events.signal });
      }
      const initialQuestionVariant = section.querySelector('[data-pixel-editorial-question-variant]');
      if (initialQuestionVariant) {
        const initialOption = section.querySelector('[data-pixel-variant]')?.selectedOptions[0];
        if (initialOption) initialQuestionVariant.value = initialOption.value;
        initialQuestionVariant.disabled = false;
      }
      // Existing pixel-commerce owns the gallery, price, quantity and cart.
      // Only new descriptive/context surfaces are synchronized here.
      section.addEventListener('change', (event) => {
        if (!event.target.matches('[data-pixel-variant]')) return;
        const option = event.target.selectedOptions[0];
        if (!option) return;
        const summary = section.querySelector('[data-pixel-editorial-selected]');
        const mobilePrice = section.querySelector('[data-pixel-editorial-mobile-price]');
        const questionVariant = section.querySelector('[data-pixel-editorial-question-variant]');
        if (summary) summary.textContent = `Selected option: ${option.textContent.trim()}`;
        if (mobilePrice) mobilePrice.textContent = option.dataset.price;
        if (questionVariant) questionVariant.value = option.value;
      }, { signal: events.signal });
      const buy = section.querySelector('[data-pixel-editorial-buy]');
      const end = section.querySelector('[data-pixel-editorial-end]');
      if (sticky && buy && end) {
        const update = () => {
          if (!section.isConnected) { cleanup(); return; }
          if (disposed) return;
          const buyRect = buy.getBoundingClientRect();
          const endRect = end.getBoundingClientRect();
          const footer = document.querySelector('footer');
          const footerRect = footer?.getBoundingClientRect();
          const footerVisible = footerRect && footerRect.top < window.innerHeight;
          sticky.hidden = !(buyRect.bottom < 0 && endRect.top > window.innerHeight && !footerVisible);
        };
        // IO can stay false across a large jump. Scroll/resize remeasure once per frame.
        const schedule = () => {
          if (disposed || frame) return;
          frame = window.requestAnimationFrame(() => { frame = 0; update(); });
        };
        window.addEventListener('scroll', schedule, { passive: true, capture: true, signal: events.signal });
        window.addEventListener('resize', schedule, { passive: true, signal: events.signal });
        if ('IntersectionObserver' in window) {
          observer = new IntersectionObserver(schedule);
          observer.observe(buy);
          observer.observe(end);
          const footer = document.querySelector('footer');
          if (footer) observer.observe(footer);
        }
        section.querySelector('[data-pixel-editorial-return]').addEventListener('click', () => {
          const target = section.querySelector('.pixel-product-form');
          target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
          (section.querySelector('[data-pixel-variant]') || section.querySelector('[data-pixel-quantity]'))?.focus({ preventScroll: true });
        }, { signal: events.signal });
        update();
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind());
  else bind();
  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();
